import React from 'react';
import { Outlet } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = () => {
  // const { user, loading } = useAuth();

  // TEMPORARY: Authentication disabled for preview
  return <Outlet />;

  // if (loading) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center">
  //       <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
  //     </div>
  //   );
  // }

  // return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
